const baseUrl =
  process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_API_URL || 'https://localhost:5001'
    : process.env.REACT_APP_API_URL || '';

export default baseUrl;
